import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { HttpClient, HttpHeaders  } from '@angular/common/http';


@Injectable({ providedIn: 'root' })
export class DataServiceService {
    private subject = new Subject<any>();
    values: object;
    price: string;
    initialPrice: string;
    monthHosthingSupport: string;
    hostingSupportTotalPrice: string;
    nbMonthHosting: string;
    serviceDuration : string;
    nbMonthPayment: string;
    finalForm: object;
    url = 'app/api/payment.php';
    urlContact = 'app/api/contact.php';
    urlPartner = 'app/api/partnership.php';
    /* url = 'http://localhost/api/payment.php';
    urlContact = 'http://localhost/api/contact.php';
    urlPartner = 'http://localhost/api/partnership.php'; */
    httpOptions = {
      headers: new HttpHeaders({
        'Content-Type' : '*/*'
      })
    };

    constructor(private http: HttpClient) {}

    sendValue(value: object) {
      this.values = value;
    }

    getValue() {
      return this.values;
    }

    sendInfo(priceValue: string, initialPrice: string, monthHosthingSupport: string, 
      hostingSupportTotalPrice: string, nbMonthHosting: string, nbMonthPayment: string) {
      this.price = priceValue;
      this.initialPrice = initialPrice;
      this.monthHosthingSupport = monthHosthingSupport;
      this.hostingSupportTotalPrice = hostingSupportTotalPrice;
      this.nbMonthHosting= nbMonthHosting;
      this.nbMonthPayment = nbMonthPayment;
      this.serviceDuration = (Number(nbMonthHosting) + 3).toString();
    }

    getPrice() {
      return this.price;
    }

    getInitialPrice() {
      return this.initialPrice;
    }

    getMonthHosthingSupport() {
      return this.monthHosthingSupport;
    }

    getHostingSupportTotalPrice() {
      return this.hostingSupportTotalPrice;
    }

    getNbMonthHosting() {
      return this.nbMonthHosting;
    }

    getNbMonthPayment(){
      return this.nbMonthPayment;
    }

    getServiceDuration() {
      return this.serviceDuration;
    }

    sendEmail(formContact: object, type: string) {
      if(type == 'pricing') {
        return this.http.post(this.url, formContact, this.httpOptions);
      }
      if(type == 'contact') {
        return this.http.post(this.urlContact, formContact, this.httpOptions);
      }
      if(type == 'partner') {
        return this.http.post(this.urlPartner, formContact, this.httpOptions);
      }
    }

}
